import React from 'react';

export default function DummyComponent() {
  return <></>;
}
